<template>
    <div>
        <el-row :gutter="20" >
            <el-col :span=12>
                <el-card>
                    <div slot="header" class="clearfix">
                        <span>修改登录密码</span>
                    </div>
                    <div>
                        <el-form ref="updatePasswordForm" :rules="updatePasswordRules" :model="updatePassword" label-width="80px">
                            <el-form-item label="原密码" prop="password">
                                <el-input  type="password" v-model="updatePassword.password"></el-input>
                            </el-form-item>
                            <el-form-item label="新密码" prop="newPassword">
                                <el-input  type="password" v-model="updatePassword.newPassword"></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码" prop="confirmPassword">
                                <el-input  type="password" v-model="updatePassword.confirmPassword"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">提交</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
            <el-col :span=12>
                <el-card>
                    <div slot="header" class="clearfix">
                        <span>修改独立密码</span>
                    </div>
                    <div>
                        <el-form ref="updateIndependentPasswordForm" :rules="updatePasswordRules" :model="independentPassword" label-width="80px">
                            <el-form-item label="原密码" prop="password">
                                <el-input  type="password" v-model="independentPassword.password"></el-input>
                            </el-form-item>
                            <el-form-item label="新密码" prop="newPassword">
                                <el-input  type="password" v-model="independentPassword.newPassword"></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码" prop="confirmPassword">
                                <el-input  type="password" v-model="independentPassword.confirmPassword"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit2">提交</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
            

    </div>
</template>

<script>
export default {
  name: "baseform",
  data: function() {
    return {
      updatePassword: {},
      independentPassword: {},
      updatePasswordRules: {
        password: [
          { required: true, message: "请输入原密码", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    async onSubmit() {
        let valid = await this.$refs.updatePasswordForm.validate().catch(err => Promise.resolve(false));
        if (!valid) {
            this.$message.error("输入有误，请重新输入");
        }
        if (this.updatePassword.newPassword !== this.updatePassword.confirmPassword) {
            this.$message.error("两次密码不一致，请重新输入");
        }
        let res = await this.$axios.post("/user/updatePassword", this.updatePassword);
        if (res.code == 200) {
            this.$message({ message: "修改成功", type: "success" });
            this.updatePassword = {};
            this.refs.updatePasswordForm.clearValidate();
        } else {
            this.$message.error(res.errMsg);
        }
    },
    async onSubmit2() {
        let valid = await this.$refs.updateIndependentPasswordForm.validate().catch(err => Promise.resolve(false));
        if (!valid) {
            this.$message.error("输入有误，请重新输入");
        }
        if (this.independentPassword.newPassword !== this.independentPassword.confirmPassword) {
            this.$message.error("两次密码不一致，请重新输入");
        }
        let res = await this.$axios.post("/manage/systemConfig/updateIndependentPassword", this.independentPassword);
        if (res.code == 200) {
            this.$message({ message: "修改成功", type: "success" });
            this.independentPassword = {};
            this.$refs.updateIndependentPasswordForm.clearValidate();
        } else {
            this.$message.error(res.errMsg);
        }
    }
  }
};
</script>